const type = 'INCREMENT_SELECTED_RESULT';

const incrementSelectedResult = () => ({
  type,
});

export { type };
export default incrementSelectedResult;
